// extracted by mini-css-extract-plugin
export var custom_bg = "PopUpModal-module--custom_bg--tpSsZ";
export var modal_body = "PopUpModal-module--modal_body--e39x8";
export var modal_close_btn = "PopUpModal-module--modal_close_btn--GfsUM";
export var modal_fade_enter = "PopUpModal-module--modal_fade_enter--dU-wo";
export var modal_fade_enter_active = "PopUpModal-module--modal_fade_enter_active---JECk";
export var modal_fade_exit = "PopUpModal-module--modal_fade_exit--1uLLL";
export var modal_fade_exit_active = "PopUpModal-module--modal_fade_exit_active--HR1CG";
export var modal_header = "PopUpModal-module--modal_header--1yYxu";
export var modal_title = "PopUpModal-module--modal_title--fOJy0";
export var no_border = "PopUpModal-module--no_border--b+ww8";
export var no_padding = "PopUpModal-module--no_padding--HpX5r";